import React, { useContext, useEffect, useState } from "react";
import {
  useExpanded,
  useSortBy,
  useTable,
  useGlobalFilter,
  usePagination,
} from "react-table";
import { RandomId } from "../../../Utils/RandomId";
import { needsReview } from "../../../Utils/partnerApproval";
import TableFooter from "../TableFooter/TableFooter";
import cashImg from "./styles/img/cash.png";
import downArrow from "../down.svg";
import upArrow from "../up.svg";
import upDownArrow from "../updownarrow.svg";
import styles from "./styles/Trustees.module.css";
import { LanguageContext } from "../../../Context/changeLanguageProvider";
export function TrusteesTable({
  columns,
  data,
  filter,
  setFilter,
  click,
  trusteesLength,
  scrollToTop=false
}) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    setPageSize,
    prepareRow,
    setGlobalFilter,
    pageOptions,
    state,
  } = useTable(
    { columns, data, autoResetExpanded: false },
    useGlobalFilter,
    useSortBy,
    useExpanded,
    usePagination
  );
  const { pageIndex, pageSize } = state;
  const websiteCurrentLang = useContext(LanguageContext).language;
  const [content, setContent] = useState(
    websiteCurrentLang.content.User.AssetType.TrusteesTable
  );
  useEffect(() => {
    setContent(websiteCurrentLang.content.User.AssetType.TrusteesTable);
  }, [websiteCurrentLang]);
  useEffect(() => {
    setGlobalFilter(filter);
  }, [filter, setGlobalFilter]);
  return (
    <>
      {/* <TableFilter filter={globalFilter} setFilter={setGlobalFilter}/> */}
      {/* <TableFilter/> */}
      <div className={styles.table_wrapper}>
        <table {...getTableProps()} className={styles.sub_table_div}>
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr
                className={styles.head_row}
                {...headerGroup.getHeaderGroupProps()}
              >
                {headerGroup.headers.map((column) => (
                  <th
                    key={RandomId(3)}
                    className={
                      styles[
                        `th_${column.id.replace(" ", "").replace("&", "")}`
                      ]
                    }
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                  >
                    <span
                      onClick={() => console.log(column)}
                      className={styles.column_title}
                    >
                      {column.render("Header")}
                    </span>
                    <div
                      className={styles.sort_icon}
                      style={{
                        background: `url(${
                          column.canSort
                            ? column.isSorted
                              ? column.isSortedDesc
                                ? downArrow
                                : upArrow
                              : upDownArrow
                            : ""
                        }) no-repeat center`,
                      }}
                    />
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          {trusteesLength ? (
            <tbody {...getTableBodyProps()}>
              {page.length === 0 && (
                <tr className={styles.no_grid}>
                  <td colSpan={4} className={styles.no_search_cell}>
                    <div className={styles.assets_empty}>
                      <img className={styles.cash_img} src={cashImg} />
                      <p>{content?.trusteesTableText1}</p>
                      <div>{content?.trusteesTableText2}</div>
                    </div>
                  </td>
                </tr>
              )}
              {page.map((row, i) => {
                prepareRow(row);
                console.log(row);
                return (
                  // <React.Fragment key={...row.getRowProps().key}>
                  <React.Fragment key={row.getRowProps().key}>
                    <tr
                      /*
                        Created by the partner and not approved yet -- marked
                        the way the Asset Management table marks its own, so
                        a row waiting on the customer looks the same wherever
                        they meet it.
                      */
                      className={`${styles.row} ${
                        needsReview(row.original)
                          ? styles.row_awaiting_approval
                          : ""
                      }`}
                      onClick={() => click(row.original)}
                    >
                      {row.cells.map((cell) => {
                        if (cell.column.id === "deleter") {
                          return (
                            <td className={styles.td} {...cell.getCellProps()}>
                              {cell.render("Cell")}
                            </td>
                          );
                        } else if (cell.column.id === "expander") {
                          return (
                            <td
                              className={styles.td}
                              onClick={() => console.log("Click on view")}
                              {...cell.getCellProps()}
                            >
                              {cell.render("Cell")}
                            </td>
                          );
                        } else {
                          return (
                            <td
                              className={
                                styles[
                                  `td_${cell.column.id
                                    .replace(" ", "")
                                    .replace("&", "")}`
                                ]
                              }
                              {...cell.getCellProps()}
                              {...row.getToggleRowExpandedProps({
                                title: undefined,
                              })}
                            >
                              {cell.render("Cell")}
                            </td>
                          );
                        }
                      })}
                    </tr>
                    {row.isExpanded ? null : null}
                  </React.Fragment>
                );
              })}
            </tbody>
          ) : (
            <tbody>
              <tr className={styles.no_grid}>
                <td colSpan={4} className={styles.no_search_cell}>
                  <div className={styles.assets_empty}>
                    <img className={styles.cash_img} src={cashImg} />
                    <div>You didn't set any trusted advisor yet</div>
                  </div>
                </td>
              </tr>
            </tbody>
          )}
        </table>
      </div>
      {trusteesLength && (
        <TableFooter
          setPageSize={setPageSize}
          pageSize={pageSize}
          maxPage={pageOptions.length}
          pageIndex={pageIndex}
          previousPage={previousPage}
          nextPage={nextPage}
          canNextPage={canNextPage}
          canPreviousPage={canPreviousPage}
          scrollToTop={scrollToTop}
        ></TableFooter>
      )}
    </>
  );
}
